import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/workspace/artifacts/legible-web/src/components/HowItWorksClient.tsx");
